import { render, staticRenderFns } from "./AdditionFee.vue?vue&type=template&id=0fd57c8c"
import script from "./AdditionFee.js?vue&type=script&lang=js&external"
export * from "./AdditionFee.js?vue&type=script&lang=js&external"
import style0 from "./AdditionFee.vue?vue&type=style&index=0&id=0fd57c8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports